/**
 * 默认的apiList（默认申请常用的api）
 */
export const DEFAULT_API_LIST = [
    /**
     * 关闭当前网页窗口接口
     */
    'closeWindow',
    /**
     * 批量显示功能按钮接口
     */
    'showMenuItems',
    /**
     * 批量隐藏功能按钮接口
     */
    'hideMenuItems',
    /**
     * 隐藏所有非基础按钮接口
     */
    'hideAllNonBaseMenuItem',
    /**
     * 显示所有功能按钮接口
     */
    'showAllNonBaseMenuItem',
    /**
     * 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
     */
    'updateTimelineShareData',
    /**
     * 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
     */
    'updateAppMessageShareData',
];
/**
 * 忽略 wx.ready，可以直接调用的 API 方法.
 *
 * invoke 方法比较特殊，通常用于调用私有api，wx.invoke是在调用后才会存在于wx对象，不一定proxy到，导致有些项目有问题。
 * 这里将invoke方法都排出在proxy之外，统一通过 safeInvoke 方法调用
 *
 * */
export const IGNORE_INIT_API_LIST = ['config', 'error', 'ready', 'closeWindow', 'invoke'];
//# sourceMappingURL=config.js.map